import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import { UserOutlined, SendOutlined } from '@ant-design/icons';
import { Row, Col, Avatar, List, Input, Button, Select } from 'antd';

const { Option } = Select;

// Sample chat histories
const chatHistories = [
  {
    id: 1,
    title: 'Chat with John Doe',
    messages: [
      {
        id: 1,
        sender: 'John Doe',
        profilePic: 'https://via.placeholder.com/40',
        message: 'Hi there! How can I help you today?',
      },
      {
        id: 2,
        sender: 'You',
        profilePic: 'https://via.placeholder.com/40',
        message: 'I have a question about your services.',
      },
    ],
  },
  {
    id: 2,
    title: 'Chat with Jane Smith',
    messages: [
      {
        id: 1,
        sender: 'Jane Smith',
        profilePic: 'https://via.placeholder.com/40',
        message: 'Hello! Do you need assistance?',
      },
      {
        id: 2,
        sender: 'You',
        profilePic: 'https://via.placeholder.com/40',
        message: 'Yes, I need help with my order.',
      },
    ],
  },
];

const IcdAgents = () => {
  const [selectedChat, setSelectedChat] = useState(chatHistories[0]); // Default to the first chat
  const [newMessage, setNewMessage] = useState('');
  const [selectedValue, setSelectedValue] = useState('');

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      const newChatMessage = {
        id: selectedChat.messages.length + 1,
        sender: 'You',
        profilePic: 'https://via.placeholder.com/40',
        message: newMessage.trim(),
      };
      const updatedChat = {
        ...selectedChat,
        messages: [...selectedChat.messages, newChatMessage],
      };
      setSelectedChat(updatedChat);
      setNewMessage('');
    }
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value);
  };

  const handleChatSelection = (chatId) => {
    const selected = chatHistories.find((chat) => chat.id === chatId);
    setSelectedChat(selected);
  };

  return (
    <div style={{ display: 'flex' }}>
      <NavBar />
      <div style={{ width: '100%', padding: '10px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginBottom: '16px',
            }}
          >
            <UserOutlined style={{ fontSize: '24px', color: 'black' }} />
            <h2 style={{ margin: 0 }}>ICD Agents</h2>
          </div>
        </div>

        <Row gutter={[1, 1]} style={{ marginTop: '20px', height: '100%' }}>
          {/* Column 1: Chat Histories */}
          <Col span={6} style={{ height: '100%', padding: '15px' }}>
            <h3>Chat Histories</h3>
            <List
              dataSource={chatHistories}
              renderItem={(item) => (
                <List.Item
                  key={item.id}
                  onClick={() => handleChatSelection(item.id)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor:
                      selectedChat.id === item.id ? '#a34fff':'transparent',
                      color : selectedChat.id === item.id ? "#fff" : "",
                    padding: '10px',
                    borderRadius: '5px',
                  }} 
                >
                  {item.title}
                </List.Item>
              )}
            />
          </Col>

          {/* Column 2: Chat Messages */}
          <Col
            span={10}
            style={{
              height: '100%',
              backgroundColor: '#a34fff0f',
              borderRadius: '2px',
              padding: '15px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* Chat Messages */}
            <div style={{ overflowY: 'auto', marginBottom: '10px' }}>
              <List
                dataSource={selectedChat.messages}
                renderItem={(item) => (
                  <List.Item
                    key={item.id}
                    style={{
                      display: 'flex',
                      flexDirection:
                        item.sender === 'You' ? 'row-reverse' : 'row',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <Avatar src={item.profilePic} alt={item.sender} size={40} />
                    <div
                      style={{
                        maxWidth: '60%',
                        padding: '8px 12px',
                        backgroundColor:
                          item.sender === 'You' ? '#fff' : '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      <strong
                        style={{
                          display: 'block',
                          marginBottom: '4px',
                          fontSize: '14px',
                        }}
                      >
                        {item.sender}
                      </strong>
                      <p style={{ margin: 0, fontSize: '14px', color: '#333' }}>
                        {item.message}
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            </div>

            {/* Input Section */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                padding: '10px',
                borderRadius: '5px',
                position: 'fixed',
                bottom: '2px',
                justifyContent: 'center',
              }}
            >
              <Select
                placeholder="Select"
                style={{ width: '80px', border: 'none' }}
                onChange={handleSelectChange}
              >
                <Option value="Option 1">Option 1</Option>
                <Option value="Option 2">Option 2</Option>
                <Option value="Option 3">Option 3</Option>
              </Select>
              <Input
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type a message..."
                style={{ flex: 1 }}
              />
              <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={handleSendMessage}
              ></Button>
            </div>
          </Col>

          {/* Column 3: Additional Content */}
          <Col span={8} style={{ height: '100%', padding: '15px' }}>
            <div>
              <h3>Column 3</h3>
              <p>Content for column 3</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default IcdAgents;
